import store from "../store";
import localStorageActions from "../../common/helpers/localStorageActions";
import { SET_SEARCH_OPTIONS, SET_USER_QUERY } from "../actions/actionTypes";
import { searchFromForm } from "./searchFromForm";
import { validate } from "./validate";

export const setGenome = (genome, userQuery) => {
  const state = store.getState();

  if (state.referenceGenomeDisabled || genome === state.genome) return;

  localStorageActions.setGenomePreference(genome);

  const variantQueryModeParams = state.variantQueryMode;
  const variantMode =
    variantQueryModeParams?.annotation_mode === "somatic"
      ? "somatic"
      : undefined;

  store.dispatch({ type: SET_USER_QUERY, userQuery });
  store.dispatch({ type: SET_SEARCH_OPTIONS, options: { genome } });

  const updatedState = store.getState();

  const userQueryValidation = validate(updatedState.userQuery);
  if (!userQueryValidation.error) {
    const queryType = updatedState.queryType === "gene" ? "gene" : null;
    searchFromForm(updatedState.userQuery, true, queryType, null, variantMode);
  }
};
